var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.editNasShow,
          expression: "editNasShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c(
        "div",
        {
          ref: "nasDiv",
          staticClass: "content",
          class: _vm.addFtp,
          attrs: { id: "editNas" }
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.addNas")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.editNasShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "add-nas-cont" },
            [
              _c("div", { staticClass: "add-nas-cont-top" }, [
                _c("div", { staticClass: "add-cloud-drive-position" }, [
                  _c("div", { staticClass: "cloud NAS-add add-nas-size" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-cloud-text" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("language.popup.addCloudPopup.addNas"))
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Via FTP", name: "first" } },
                    [_c("tab1", { ref: "viaFtp" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Via WebDAV", name: "second" } },
                    [_c("tab2", { ref: "viaWebDav" })],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: { float: "right" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.reWriteNasSubmit()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.connect,
                          expression: "!connect"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("language.common.add")) +
                          "  " +
                          _vm._s(_vm.cloudName) +
                          " " +
                          _vm._s(_vm.$t("language.common.account"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.connect,
                          expression: "connect"
                        }
                      ]
                    },
                    [
                      _vm._v(_vm._s(_vm.$t("language.common.connecting"))),
                      _c("span", { staticClass: "cloudDotting" })
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-747e25b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747e25b5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/edit_nas_popup.vue
// module id = null
// module chunks = 